var map = {
	"./provider1.png": 6260,
	"./provider10.png": 8286,
	"./provider2.png": 3119,
	"./provider3.png": 6182,
	"./provider4.png": 6265,
	"./provider5.png": 1792,
	"./provider6.png": 123,
	"./provider7.png": 5298,
	"./provider8.png": 6149,
	"./provider9.png": 236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2680;